export enum PricingActualTypePeriod {
	MONTHLY = "monthly",
	ANNUAl = "annual",
}

export enum PricingActualPlans {
	SUBSCRIPTION_PLANS = "SUBSCRIPTION PLANS",
	THE_CORE = "THE CORE",
	PRE_COURSES = "PRE-COURSES",
	SKILL_BUNDLES = "SKILL BUNDLES",
	PACKS = "PACKS",
}
